import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .focus-outline-hidden :focus {
      outline: none;
  }
`
